import { useAuth } from "../../store/AuthContext";
import {
  userHasPermission as guardUserHasPermission,
  userHasRole as guardUserHasRole,
  userIsDev as guardUserIsDev,
  userIs as guardUserIs,
} from "../../utils/auth/guardService";

/** Binds the guard helpers to the Cosmos person loaded after login. */
export function useGuard() {
  const { tokenDecoded, loggedPerson } = useAuth();
  const permissions = tokenDecoded?.extension_WSG_Permissions ?? [];
  const user = loggedPerson ?? null;

  return {
    user,
    userHasRole: (role: string | string[]) => guardUserHasRole(user, role),
    userHasPermission: (permission: string | string[]) => guardUserHasPermission(user, permission),
    userIsDev: () => guardUserIsDev(user),
    userIs: (type: string) => guardUserIs(user, type),
  };
}
